
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import nsa2a659d484d52ec3f9ca723310690319en from './en.yaml'
            i18n.addResourceBundle('en', 'a2a659d484d52ec3f9ca723310690319', flattenObject(nsa2a659d484d52ec3f9ca723310690319en), true, true);
        
        export default 'a2a659d484d52ec3f9ca723310690319';
    